/* לוגיקת טופס יצירת הקשר — מנותקת מה-UI. */
import { CONTACT_FORM } from '@/dictionary/common';
import { ApiError } from '@/services/api-client';
import { sendContactRequest } from '@/services/contact.service';
import { useMutation } from '@tanstack/react-query';
import type { ContactRequest } from '@shared/contact.types';
import { useState } from 'react';

interface UseContactFormResult {
  submit: (payload: ContactRequest) => void;
  isSubmitting: boolean;
  errorMessage: string | null;
  isSuccessOpen: boolean;
  closeSuccess: () => void;
}

export function useContactForm(onSuccess?: () => void): UseContactFormResult {
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const mutation = useMutation({
    mutationFn: sendContactRequest,
    /* סגירת חלון ההצלחה בכל שליחה חדשה, כדי שלא יוצג יחד עם הודעת שגיאה */
    onMutate: () => setIsSuccessOpen(false),
    onSuccess: (response) => {
      if (!response.success) {
        throw new ApiError(response.message, 400);
      }
      setIsSuccessOpen(true);
      onSuccess?.();
    },
  });
  const errorMessage = mutation.isError
    ? mutation.error instanceof ApiError
      ? mutation.error.message
      : CONTACT_FORM.genericError
    : null;

  return {
    submit: (payload: ContactRequest) => mutation.mutate(payload),
    isSubmitting: mutation.isPending,
    errorMessage,
    isSuccessOpen,
    closeSuccess: () => setIsSuccessOpen(false),
  };
}
